import { HTMLAttributes } from 'react'

export const CloseButton = (props: HTMLAttributes<HTMLButtonElement>) => (
  <button
    type="button"
    className="size-10 rounded-full bg-[linear-gradient(0deg,#C91D26.29%,#E0565D_447.79%)] shadow-[0_2px_0px_#6C1B1B,0_4px_4px_rgba(38,3,47,0.25),inset_0_4px_0px_#E24137] flex items-center justify-center"
    {...props}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={19}>
      <path
        fill="#D9D9D9"
        d="M14.675.665a2.078 2.078 0 0 1 2.873 0l1.366 1.324a1.925 1.925 0 0 1 0 2.783l-4.687 4.541 4.687 4.541a1.925 1.925 0 0 1 0 2.783l-1.366 1.324a2.078 2.078 0 0 1-2.873 0L9.987 13.42 5.3 17.961a2.078 2.078 0 0 1-2.873 0L1.06 16.637a1.925 1.925 0 0 1 0-2.783l4.687-4.541L1.06 4.772a1.925 1.925 0 0 1 0-2.783L2.427.665a2.078 2.078 0 0 1 2.873 0l4.687 4.54 4.688-4.54Z"
      />
    </svg>
  </button>
)
